<template>
  <div class="replay-search-wrap">
    <el-form ref="form" :model="model" :inline="true" :rules="rules">
      <el-form-item :label="'机构:' | translateTo" prop="officeId">
        <el-tree-select v-model="model.officeId" :treeParams="officeTreeParams"></el-tree-select>
      </el-form-item>
      <el-form-item :label="'设备:' | translateTo" prop="sn">
        <el-select v-model="model.sn" clearable multiple collapse-tags filterable>
          <el-option
            v-for="item in deviceList"
            :key="item.sn"
            :label="item.name"
            :value="item.sn"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="'时间:' | translateTo" prop="rangeDateVal">
        <el-date-picker
          v-model="model.rangeDateVal"
          type="daterange"
          :range-separator="'至' | translateTo"
          :start-placeholder="'开始日期' | translateTo"
          :end-placeholder="'结束日期' | translateTo"
          value-format="timestamp"
          clearable
        ></el-date-picker>
      </el-form-item>
      <!-- <el-form-item :label="'回放速度' | translateTo" prop="playSpeed">
        <el-select v-model="model.speed">
          <el-option label="1x" :value="1" />
          <el-option label="1.5x" :value="1.5" />
          <el-option label="2x" :value="2" />
        </el-select>
      </el-form-item> -->
      <el-form-item>
        <el-button type="primary" @click="validateEvent" :loading="loading">
          {{ '查询' | translateTo }}
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { getOffice } from '@/api/auth';
import { getDevicesList } from '@/api/baseInfo';
import { toTimestamp } from '@/utils/date';

export default {
  components: {
    ElTreeSelect: () => import('@/components/elTreeSelect/index.vue')
  },
  props: {
    model: {
      type: Object,
      default: () => {}
    },
    deviceList: {
      type: Array,
      default: () => []
    },
    deviceModelBusiType: Number,
    rules: {
      type: Object,
      default: () => ({})
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      officeTreeParams: {
        data: [],
        checkStrictly: true,
        props: {
          value: 'id',
          label: 'name',
          children: 'children'
        }
      }
    };
  },
  methods: {
    dateChange(val) {
      if (!val[0] || !val[1]) return;
      const begin = toTimestamp(val[0], 'm');
      const end = toTimestamp(val[1], 'm');
      if (end - begin > 36e5) {
        this.model.rangeDateVal.splice(0, Infinity, begin, begin + 36e5);
      } else {
        this.model.rangeDateVal.splice(0, Infinity, begin, end);
      }
    },
    getOfficeList() {
      getOffice({
        busiType: 2
      }).then(res => {
        Object.assign(this.officeTreeParams, { data: res.data });
      });
    },
    taskChange() {
      this.getDeviceList();
    },
    getDeviceList() {
      const officeId = this.model.officeId;
      getDevicesList({ officeId }).then(res => {
        this.deviceList.splice(0, Infinity, ...res.data);
      });
    },
    resetDevice() {
      this.model.sns.splice(0, Infinity);
    },
    validateEvent() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.$emit('replay', this.model);
        } else {
          return false;
        }
      });
    }
  },
  created() {
    this.getOfficeList();
    this.model.officeId && this.getDeviceList();
  },
  mounted() {
    this.$nextTick(() => {
      this.validateEvent();
    });
  },
  watch: {
    'model.officeId'(n) {
      if (n) {
        this.getDeviceList();
      } else {
        this.model.sn.splice(0, Infinity);
        this.deviceList.splice(0, Infinity);
      }
    }
  }
};
</script>

<style></style>
